module.exports = __webpack_public_path__ + "static/img/avatar1.bc1b182.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/avatar1.png
// module id = OTUQ
// module chunks = 0